import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserManagement.css';
import axios from 'axios';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const UserManagement = () => {
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openSuspendModal, setOpenSuspendModal] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [isActivate, setIsActivate] = useState(true);
    const [currentPage, setCurrentPage] = useState(Number(localStorage.getItem('cur-u-page')) || 1);
    const [data, setData] = useState([]);
    const [displayedUsers, setDisplayedUsers] = useState([]);
    const [searchData, setSearchData] = useState({
        persian_lname: localStorage.getItem('u-lastname') || '',
        faculty: localStorage.getItem('u-faculty') || '',
        scientific_rank: localStorage.getItem('u-rank') || '',
        professor_number: localStorage.getItem('u-number') || '',
    });
    const navigate = useNavigate();
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    const scientificRank = [
        '--------',
        'مربی',
        'استادیار',
        'دانشیار',
        'استاد',
    ];

    const faculty = [
        '--------',
        'مهندسی کامپیوتر',
        'مهندسی برق',
        'مهندسی مکانیک',
        'مهندسی عمران',
        'مهندسی هوافضا',
        'مهندسی صنایع',
        'مهندسی و علم مواد',
        'مهندسی نقشه برداری',
        'ریاضی',
        'فیزیک',
        'شیمی',
        'مركز آموزش هاي عمومی',
    ];

    const maxPageButtons = 5;
    const pageSize = 5;

    useEffect(() => {
        localStorage.setItem('u-lastname', searchData.persian_lname);
        localStorage.setItem('u-faculty', searchData.faculty);
        localStorage.setItem('u-rank', searchData.scientific_rank);
        localStorage.setItem('u-number', searchData.professor_number);
    }, [searchData]);

    useEffect(() => {
        localStorage.removeItem('r-type');
        localStorage.removeItem('r-title');
        localStorage.removeItem('r-language');
        localStorage.removeItem('cur-r-page');

        const fetchData = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${API_URL}/user-management/user-list?persian_lname=${searchData.persian_lname}&faculty=${searchData.faculty}&scientific_rank=${searchData.scientific_rank}&professor_number=${searchData.professor_number}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setData(response.data);
                let endIndex = pageSize * currentPage;
                let startIndex = endIndex - pageSize;
                let usersList = response.data.slice(startIndex, endIndex);
                setDisplayedUsers(usersList);
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        };
        fetchData();

        const handleBeforeUnload = () => {
            localStorage.removeItem('u-lastname');
            localStorage.removeItem('u-faculty');
            localStorage.removeItem('u-rank');
            localStorage.removeItem('u-number');
            localStorage.removeItem('cur-u-page');
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        const filterData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await axios.get(`${API_URL}/user-management/user-list?persian_lname=${searchData.persian_lname}&faculty=${searchData.faculty}&scientific_rank=${searchData.scientific_rank}&professor_number=${searchData.professor_number}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                setData(response.data);
                const totalPages = Math.ceil(response.data.length / pageSize);
                if (currentPage > totalPages) {
                    setCurrentPage(totalPages > 0 ? totalPages : 1);
                }
                let endIndex = pageSize * currentPage;
                let startIndex = endIndex - pageSize;
                let usersList = response.data.slice(startIndex, endIndex);
                setDisplayedUsers(usersList);
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        };
        filterData();
    }, [searchData]);

    useEffect(() => {
        localStorage.setItem('cur-u-page', currentPage);
        let endIndex = pageSize * currentPage;
        let startIndex = endIndex - pageSize;
        let usersList = data.slice(startIndex, endIndex);
        setDisplayedUsers(usersList);
    }, [currentPage]);

    const totalPages = Math.ceil(data.length / pageSize);

    const getPaginationButtons = () => {
        const buttons = [];
        const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
        const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <button
                    className={`pagination-btn ${i === currentPage ? "active" : ""}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }
        return buttons;
    };

    const redirectToProfile = async (id) => {
        navigate('/admin/user-management/profile/' + id);
    };

    const redirectToActivities = async (id, prof_fname, prof_lname) => {
        navigate('/admin/user-management/activities/' + id, { state: { name: `${prof_fname} ${prof_lname}` } });
    };

    const handleChange = (event) => {
        setCurrentPage(1);
        setSearchData({
            ...searchData,
            [event.target.name]: event.target.value,
        });
    };

    const handleDeleteUser = async () => {
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${API_URL}/user-management/user/` + selectedRowId, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                setModalData({
                    isVisible: true,
                    message: 'کاربر با موفقیت حذف شد',
                    type: 'success',
                });
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        } finally {
            setOpenDeleteModal(false);
            const timer = setTimeout(() => {
                window.location.reload();
            }, 1000);
            return () => clearTimeout(timer);
        }
    };

    const handleSuspendUser = async () => {
        const suspendData = {
            activate_situation: !isActivate,
        };
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${API_URL}/user-management/user/` + selectedRowId, {
                method: 'PUT',
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(suspendData),
            });
            if (response.ok) {
                isActivate ? (
                    setModalData({
                        isVisible: true,
                        message: 'کاربر با موفقیت تعلیق شد',
                        type: 'success',
                    })
                ) : (
                    setModalData({
                        isVisible: true,
                        message: 'کاربر از تعلیق خارج شد',
                        type: 'success',
                    })
                );
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        } finally {
            setOpenSuspendModal(false);
            const timer = setTimeout(() => {
                window.location.reload();
            }, 1000);
            return () => clearTimeout(timer);
        }
    };

    return (
        <div className="professors-list-container container">
            <div className="professors-card">
                <header className="card-header">
                    <h1 className="header-title">فهرست اساتید</h1>
                </header>
                <div className="search-container">
                    <div className="search-group">
                        <label htmlFor="persian_lname">نام خانوادگی</label>
                        <input
                            id="persian_lname"
                            name="persian_lname"
                            type="search"
                            placeholder=""
                            value={searchData.persian_lname}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="search-group">
                        <label htmlFor="faculty">دانشکده</label>
                        <select
                            id="faculty"
                            name="faculty"
                            type="search"
                            value={searchData.faculty}
                            onChange={handleChange}
                        >
                            {faculty.map((fac) => (
                                fac !== '--------' ? (
                                    <option className="light-text" value={fac}>{fac}</option>
                                ) : (
                                    <option className="light-text" value="">{fac}</option>
                                )
                            ))}
                        </select>
                    </div>
                    <div className="search-group">
                        <label htmlFor="scientific_rank">مرتبه علمی</label>
                        <select
                            id="scientific_rank"
                            name="scientific_rank"
                            type="search"
                            value={searchData.scientific_rank}
                            onChange={handleChange}
                        >
                            {scientificRank.map((rank) => (
                                rank !== '--------' ? (
                                    <option className="light-text" value={rank}>{rank}</option>
                                ) : (
                                    <option className="light-text" value="">{rank}</option>
                                )
                            ))}
                        </select>
                    </div>
                    <div className="search-group">
                        <label htmlFor="professor_number">شماره استادی</label>
                        <input
                            id="professor_number"
                            name="professor_number"
                            type="search"
                            placeholder=""
                            value={searchData.professor_number}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="card-body">
                    <table className="professors-table">
                        <thead>
                            <tr>
                                <th>نام</th>
                                <th className="last-name">نام خانوادگی</th>
                                <th className="prof-number">شماره استادی</th>
                                <th className="faculty">دانشکده</th>
                                <th className="department">گروه آموزشی</th>
                                <th>تاریخ ایجاد</th>
                                <th className="scientific-rank">مرتبه علمی</th>
                                <th>کد ملی</th>
                                <th className="action-table">عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedUsers.length > 0 ? (
                                displayedUsers.map((user) => (
                                    <tr key={user.id}>
                                        <td>{user.persian_fname}</td>
                                        <td>{user.persian_lname}</td>
                                        <td>{user.professor_number}</td>
                                        <td>{user.faculty}</td>
                                        <td>{user.department}</td>
                                        <td>{user.created_at}</td>
                                        <td>{user.scientific_rank}</td>
                                        <td>{user.national_number}</td>
                                        <td className="action-table">
                                            <div className="actions">
                                                <button className="action-button delete medium-text" onClick={() => {
                                                    setSelectedRowId(user.user_id);
                                                    setOpenDeleteModal(true);
                                                }}>حذف</button>
                                                <button className="action-button suspend medium-text" onClick={() => {
                                                    setSelectedRowId(user.user_id);
                                                    setIsActivate(user.is_active);
                                                    setOpenSuspendModal(true);
                                                }}>{user.is_active ? 'تعلیق' : 'عدم تعلیق'}</button>
                                                <button className="action-button view medium-text" onClick={() => redirectToProfile(user.user_id)}>پروفایل</button>
                                                <button className="action-button update medium-text" onClick={() => redirectToActivities(user.user_id, user.persian_fname, user.persian_lname)}>رزومه</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={10} className="no-data">
                                        داده مورد نظر در دسترس نیست
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className="pagination-container">
                        <button
                            className="pagination-btn medium-text"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            قبلی
                        </button>
                        {getPaginationButtons()}
                        <button
                            className="pagination-btn medium-text"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                        >
                            بعدی
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                message={modalData.message}
                type={modalData.type}
                isVisible={modalData.isVisible}
                onClose={() => setModalData({ ...modalData, isVisible: false })}
            />
            {openDeleteModal && (
                <div className="dialog-overlay">
                    <div className="dialog">
                        <h2 className="dialog-title">تایید حذف کاربر</h2>
                        <p className="dialog-content">آیا از حذف کردن کاربر اطمینان دارید؟</p>
                        <div className="dialog-actions">
                            <button className="dialog-button cancel medium-text" onClick={() => setOpenDeleteModal(false)}>خیر</button>
                            <button className="dialog-button confirm medium-text" onClick={handleDeleteUser}>بله</button>
                        </div>
                    </div>
                </div>
            )}
            {openSuspendModal && isActivate && (
                <div className="dialog-overlay">
                    <div className="dialog">
                        <h2 className="dialog-title">تایید تعلیق کاربر</h2>
                        <p className="dialog-content">آیا از تعلیق کردن کاربر اطمینان دارید؟</p>
                        <div className="dialog-actions">
                            <button className="dialog-button cancel medium-text" onClick={() => setOpenSuspendModal(false)}>خیر</button>
                            <button className="dialog-button confirm medium-text" onClick={handleSuspendUser}>بله</button>
                        </div>
                    </div>
                </div>
            )}
            {openSuspendModal && !isActivate && (
                <div className="dialog-overlay">
                    <div className="dialog">
                        <h2 className="dialog-title">تایید عدم تعلیق کاربر</h2>
                        <p className="dialog-content">آیا از عدم تعلیق کاربر اطمینان دارید؟</p>
                        <div className="dialog-actions">
                            <button className="dialog-button cancel medium-text" onClick={() => setOpenSuspendModal(false)}>خیر</button>
                            <button className="dialog-button active medium-text" onClick={handleSuspendUser}>بله</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserManagement;